// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import registerServiceWorker from './registerServiceWorker';

// ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';

import './css/auth_react-select2-override.css';
import './css/appglobal_normalize.css';
import './css/appglobal_base.css';
import './css/appglobal_layout.css';
import './css/auth_orders-list.css';
import './css/auth_order-form.css';
import './css/auth_fuelfarm_fueltrucks.css';
import './css/auth_reports.css';
import './css/public_authentication-pages.css';
import './css/public_marketing-pages.css';

// window.$ = window.jQuery=require('jquery')
import $ from 'jquery';
window.jQuery = window.$ = $;

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js